import { createOverlayModel } from "./overlayLayer.js"

let overlayModel = createOverlayModel()

export default overlayModel



// WEBPACK FOOTER //
// ./src/components/utils/overlayModel.js